<template>
    <transition name="fade">
                 enter-active-class="animated tada"
                 leave-active-class="animated bounceOutRight">
        <div class="call-back-app__question-button call-back-app__animation-first-step" v-on:click="$emit('show-form')"></div>
    </transition>
</template>

<script>
    export default {
        data: function () {
            return {}
        },
    }

</script>

<style scoped>
    .call-back-app__question-button {
        width: 75px;
        height: 70px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("/dist/img/clbquestcloud.webp");
        cursor: pointer;
        position: absolute;
        bottom: 20px;
        right: 20px;
        z-index: 1;
        filter: drop-shadow(0px 0px 2px #647484);
    }

    .call-back-app__question-button:after {
        content: "";
        width: 70px;
        height: 70px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto;
        background-image: url("/dist/img/clbquestcloud2.webp");
        position: absolute;
        top: -2px;
        left: 3px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

</style>


// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/callback/QuestionButton.vue